import { Component, inject, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CookieServiceWrapper } from '../../core/services/cookie.service';

@Component({
  selector: 'app-cookies-banner',
  templateUrl: './cookies-banner.component.html',
  styleUrls: ['./cookies-banner.component.css']
})
export class CookiesBannerComponent implements OnInit{

  consentGiven!: boolean;
private cookieService=inject(CookieServiceWrapper)
  constructor() {}

  ngOnInit() {
    this.consentGiven = this.cookieService.getConsentCookie();
  }

  acceptCookies() {
    this.cookieService.setConsentCookie(true);
    this.consentGiven = true;
  }

  rejectCookies() {
    this.cookieService.setConsentCookie(false);
    this.consentGiven = false;
  }
}
